import { render, staticRenderFns } from "./BasePaginationEjected.vue?vue&type=template&id=0df66de2&"
import script from "./BasePaginationEjected.vue?vue&type=script&lang=ts&"
export * from "./BasePaginationEjected.vue?vue&type=script&lang=ts&"
import style0 from "./BasePaginationEjected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports